import { faStar, faClock } from "@fortawesome/pro-regular-svg-icons";
import { faPuzzle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import formatDateString from "../../Util/functions/FormatDateString";
import { useContext } from "react";
import { AppContext } from "../../Util/contexts/AppContext";
import formatTimeString from "../../Util/functions/FormatTimeString";
import {
  getClientTimezoneOffset,
  getClientTimezoneName,
} from "../../Util/functions/TimeZone";
const CompletionHistorySection = ({
  selectedCompletionIndex,
  index,
  setSelectedCompletionIndex,
  date,
  score,
  examName,
}) => {
  const { userData } = useContext(AppContext);
  const { TimeZone } = userData;

  return (
    <div
      className={`completionHistorySectionContainer ${
        selectedCompletionIndex === index
          ? "completionHistoryContainerSelected"
          : ""
      }`}
      onClick={() => setSelectedCompletionIndex(index)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          setSelectedCompletionIndex(index);
        }
      }}
      tabIndex={0}
    >
      <div className="completionHistorySectionBodyWrapper">
        <h3 className="completionHistoryDate">
          {formatDateString(
            date,
            userData.TimeZoneOverride
              ? getClientTimezoneName()
              : userData.TimeZone
          )}
        </h3>
        <div className="completionHistoryIconValueWrapper">
          <FontAwesomeIcon
            icon={faClock}
            className="completionsHistoryValueIcon"
          />
          <p>
            {formatTimeString(
              date,
              userData.TimeZoneOverride
                ? getClientTimezoneName()
                : userData.TimeZone
            )}
          </p>
        </div>
        <div className="completionHistoryIconValueWrapper">
          <FontAwesomeIcon
            icon={faStar}
            className="completionsHistoryValueIcon"
          />
          <p>
            {Number(score).toLocaleString(undefined, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })}
            %
          </p>
        </div>
      </div>
      <div className="completionHistorySectionFooterContainer">
        <FontAwesomeIcon
          icon={faPuzzle}
          className="completionHistoryFooterIcon"
        />
        <p>{examName}</p>
      </div>
    </div>
  );
};

export default CompletionHistorySection;
